$(->
  
  # 8/9/17 - brittany@careerplug.com - This appears to be stale; I cannot find anywhere this function is called. 10/6 - I'm leaving it here rather than putting it in the stale directory since it's a standalone function.  We should determine whether we'll need this in future.
  handle_employee_error = (jqXHR,textStatus,errorThrown)->
    errors = eval('(' + jqXHR.responseText + ')')
    for attr, e of errors
      if attr.indexOf('applicant.') > -1
        id = '#app_applicant_attributes_' + attr.replace('applicant.','') + '_input'
        $(id + ' p.inline-errors').remove()
        $(id).addClass('error').append('<p class="inline-errors">' + e[0])


  add_employee_row = (data, selector)->
    new_li = $('.employees').data('blank')
    $('.employees ' + selector).append(new_li)
    $('.employees ' + selector + ' .employee:last .emp_select').attr('value', data.id)
    $('.employees ' + selector + ' .employee:last .applicant_firstname').attr('value', data.applicant.firstname)
    $('.employees ' + selector + ' .employee:last .applicant_lastname').attr('value', data.applicant.lastname)
    $('.employees ' + selector + ' .employee:last .applicant_email').attr('value', data.applicant.email)

  $('.new_employee a.add_employee').click ->
    the_link = $(this)
    missing = false
    the_link.closest('.new_employee').find('input').each ->
      $(this).parent().removeClass('error')
      $(this).parent().find('span.error-desc').remove()
      if $(this).val() == null || $(this).val() == "" || $(this).val() == $(this).attr('placeholder')
        $(this).parent().addClass('error')
        $(this).parent().append('<span class="error-desc">can&rsquo;t be blank</span>')
        missing = true

    unless missing
      the_link.parent().addClass('loading')
      $.post('/manage/employees.json', the_link.closest('.new_employee').find('input').serialize())
        .done((data, textStatus, jqXHR)->
          add_employee_row(data,'.selected')
          $('.employees .selected .employee:last .emp_select').prop('checked',true)
          $('.new_employee input.reset').val('')
        )
        .fail((jqXHR, textStatus, errorThrown)->
          errors = eval('[' + jqXHR.responseText + ']')
          for key, value of errors[0]
            fkey = null
            if key.indexOf('user') == 0
              fkey = key.replace('user.','applicant_')
            if key.indexOf('applicant') == 0
              fkey = key.replace('.','_')
            if fkey != null && $('#new_' + fkey).parent().find('span.error-desc').length < 1
              $('#new_' + fkey).parent().addClass('error')
              $('#new_' + fkey).parent().append('<span class="error-desc">' + value[0] + '</span>')
        )
        .always((jqXHR, textStatus, errorThrown)->
          the_link.parent().removeClass('loading')
        )

    false

  if $('.employees a.update_employee').length > 0
    $('.employees a.update_employee').first().closest('form').submit ->
      if $(this).find('fieldset.employee.changed').length > 0
        window.get_modal_markup().html(window.get_modal_content('', 'You have updated employees.  Please click the Save button next to each changed employee before continuing.', '<button type="button" class="btn btn-primary" data-dismiss="modal">OK</button>')).modal()
        false
      else
        true

  $(document).on 'click', '.employees a.update_employee', ->
    missing = false
    $(this).closest('.employee').find('input').each ->
      $(this).parent().removeClass('error')
      $(this).parent().find('span.error-desc').remove()
      if $(this).val() == null || $(this).val() == "" || $(this).val() == $(this).attr('placeholder')
        $(this).parent().addClass('error')
        $(this).parent().append('<span class="error-desc">can&rsquo;t be blank</span>')
        missing = true

    unless missing
      the_link = $(this)
      the_link.parent().addClass('loading')
      $.ajax({ url: '/manage/employees/' + the_link.closest('.employee').find('.emp_select').val() + '.json', data: $(this).closest('.employee').find('input').serialize(), type: 'PATCH' })
        .done((data, textStatus, jqXHR)->
          the_link.closest('fieldset.employee').removeClass('changed')
        )
        .fail((jqXHR, textStatus, errorThrown)->
          errors = eval('[' + jqXHR.responseText + ']')
          the_emp = the_link.closest('.employee')
          for key, value of errors[0]
            fkey = null
            if key.indexOf('user') == 0
              fkey = key.replace('user.','applicant_')
            if key.indexOf('applicant') == 0
              fkey = key.replace('.','_')
            if fkey != null && the_emp.find('.' + fkey).parent().find('span.error-desc').length < 1
              the_emp.find('.' + fkey).parent().addClass('error')
              the_emp.find('.' + fkey).parent().append('<span class="error-desc">' + value[0] + '</span>')
        )
        .always((jqXHR, textStatus, errorThrown)->
          the_link.parent().removeClass('loading')
        )

    false

  $('.new_employee input').focus ->
    $(this).parent().removeClass('error')
    $(this).parent().find('span.error-desc').remove()

  update_employee_filter = ->
    $('.available').html('')
    $.get '/manage/employees.json', $('#employee-filter input, #employee-filter select').serialize(), (data, textStatus, jqXHR)->
      $.each data, (i,o)->
        add_employee_row(o, '.available')

  $('#employee-filter select').change ->
    update_employee_filter()

  $('#employee-filter a.search').click ->
    update_employee_filter()
    false

  $(document).on 'show.bs.modal', '#remove_employee_form', (e)->
    the_link = $(e.relatedTarget)
    the_employee = the_link.closest('.employee')
    $('#remove_employee_form .modal-footer button.remove').click ->
      $.ajax({
        url: '/manage/employees/' + the_employee.find('.emp_select').val() + '.json',
        data: $('#remove_employee_fields').serialize(),
        type: 'PATCH'
        dataType: 'json'
        cache: false
        success: (data)->
          the_employee.remove()
          $('#remove_employee_form').modal('hide')
      })

  $(document).on 'click', '.toggle-all', (ev)->
    if $(this).hasClass('add')
      $('.employees .available .employee').each ->
        $(this).find('.emp_select').prop('checked', true)
        $('.employees .selected').append($(this))
    else
      $('.employees .selected .employee').each ->
        $(this).find('.emp_select').prop('checked', false)
        $('.employees .available').append($(this))
    false

  if $('.employees .available').length > 0
    $(document).on 'change', '.emp_select', (ev)->
      if $(this).prop('checked')
        $('.employees .selected').append($(this).closest('.employee'))
      else
        $('.employees .available').append($(this).closest('.employee'))

  $(document).on 'change', 'fieldset.employees fieldset.employee .form-group input', (ev)->
    $(this).closest('fieldset.employee').addClass('changed')

  # EVALUATIONS/REPORTS

  # 8/10/17 - brittany@careerplug.com - I believe the following two click handlers are related to evaluations and reports.  They are associated with manage/base/_new_user.html.erb and manage/base/_user_row.html.erb; the new_user partial is rendered by manage/teams/_form.html.erb.  Those partials are not rendered on the signup page or when adding or editing individual employees from the Team page.

  $('.new_user a.add_user').click ->
    missing = false
    $(this).closest('.new_user').find('input').each ->
      $(this).parent().removeClass('error')
      $(this).parent().find('span.error-desc').remove()
      if $(this).val() == null || $(this).val() == "" || $(this).val() == $(this).attr('placeholder')
        $(this).parent().addClass('error')
        $(this).parent().append('<span class="error-desc">can&rsquo;t be blank</span>')
        missing = true

    unless missing
      $.post('/manage/users.json', $(this).closest('.new_user').find('input,select').serialize())
        .done((data, textStatus, jqXHR)->
          if $('.users').length > 0
            new_li = $('.users').data('blank')
            $('.users').append(new_li)
            $('.users .user:last .user_select').attr('value', data.id).prop('checked',true)
            $('.users .user:last .user_firstname').attr('value', $('#new_user_firstname').val())
            $('.users .user:last .user_lastname').attr('value', $('#new_user_lastname').val())
            $('.users .user:last .user_email').attr('value', $('#new_user_email').val())
            $('.users .user:last .user_role').val($('#new_user_role').val())

          if $('.users_select').length > 0
            $('.users_select').append('<option value="' + data.id + '">' + $('#new_user_firstname').val() + ' ' + $('#new_user_lastname').val() + '</option>')
            $('.users_select').val(data.id)

          $('.new_user input.reset').val('')
        )
        .fail((jqXHR, textStatus, errorThrown)->
          errors = eval('[' + jqXHR.responseText + ']')
          for key, value of errors[0]
            if key != null && $('#new_' + key).parent().find('span.error-desc').length < 1
              $('#new_' + key).parent().addClass('error')
              $('#new_' + key).parent().append('<span class="error-desc">' + value[0] + '</span>')
        )

    false

  # See note above

  $(document).on 'click', '.users a.update_user', ->
    missing = false
    $(this).closest('.user').find('input[type="text"]').each ->
      $(this).parent().removeClass('error')
      $(this).parent().find('span.error-desc').remove()
      if $(this).val() == null || $(this).val() == "" || $(this).val() == $(this).attr('placeholder')
        $(this).parent().addClass('error')
        $(this).parent().append('<span class="error-desc">can&rsquo;t be blank</span>')
        missing = true

    unless missing
      the_link = $(this)
      $.ajax({ url: '/manage/users/' + the_link.closest('.user').find('.user_select').val() + '.json', data: $(this).closest('.user').find('input,select').serialize(), type: 'PATCH' })
        .done((data, textStatus, jqXHR)->
          the_link.after('<span class="result">Updated</span>')
          setTimeout(->
            the_link.siblings('span.result').remove()
          , 5000)
        )
        .fail((jqXHR, textStatus, errorThrown)->
          errors = eval('[' + jqXHR.responseText + ']')
          the_user = the_link.closest('.user')
          for key, value of errors[0]
            if key != null && the_user.find('.' + key).parent().find('span.error-desc').length < 1
              the_user.find('.' + key).parent().addClass('error')
              the_emp.find('.' + key).parent().append('<span class="error-desc">' + value[0] + '</span>')
        )

    false

  # EVALUATIONS: ADDING NEW USER TO TEAM ADMINSTRATORS?

  $('.new_user input').focus ->
    $(this).parent().removeClass('error')
    $(this).parent().find('span.error-desc').remove()

)
